module.exports = __webpack_public_path__ + "static/media/SketchPng251fc0195a2bcfe8081f6109ab32d3f7d7a1ee590f4d93de8175c9fcdf920429.08e7ad59.png";